module.exports = __webpack_public_path__ + "static/integration/img/ally-icon-seizure-flag.45a489f91e27ee94736edbac1acf7be8.svg";